import { baseApi } from "../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../core/data/rtk/apiResponseType";
import { FeeTypeResponseType, Data } from "../types/feeTypeResponse";
import { FeeTypePayloadType } from "../types/feeTypeRequest";

export const feeTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFeeTypes: builder.query<
      ApiResponseType<Data>,
      { size?: number; search?: string; page?: number }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());

        return `fee-types/get-all?${queryParams.toString()}`;
      },
      providesTags: ["FeeTypes"],
    }),
    addFeeType: builder.mutation<
      ApiResponseType<{ feeType: FeeTypeResponseType }>,
      FeeTypePayloadType
    >({
      query: (payload) => ({
        url: "fee-types/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["FeeTypes"],
    }),
    getFeeTypeById: builder.query<
      ApiResponseType<{ feetype: FeeTypeResponseType }>,
      { id: string }
    >({
      query: ({ id }) => `fee-types/get/${id}`,
      providesTags: ["FeeTypes"],
    }),
    updateFeeType: builder.mutation<
      ApiResponseType<{ feeType: FeeTypeResponseType }>,
      { id: string; payload: FeeTypePayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `fee-types/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["FeeTypes"],
    }),
    deleteFeeType: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `fee-types/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FeeTypes"],
    }),
  }),
});

export const {
  useGetAllFeeTypesQuery,
  useAddFeeTypeMutation,
  useGetFeeTypeByIdQuery,
  useUpdateFeeTypeMutation,
  useDeleteFeeTypeMutation,
} = feeTypeApi;
